import { Action } from 'redux';
import { MediaQuery } from 'models/MediaQueryService';
import { setCookie } from 'utils';

export interface BreakpointType {
  currentBreakpoint: number;
}
export const UPDATE_CURRENT_BREAKPOINT = 'UPDATE_CURRENT_BREAKPOINT';

export interface ResponsiveParams {
  breakpoint: number;
}
export interface ResponsiveAction extends ResponsiveParams, Action {}

export const updateCurrentBreakpoint = (params: ResponsiveParams): ResponsiveAction => ({
  type: UPDATE_CURRENT_BREAKPOINT,
  ...params
});

export const currentBreakpointSmall = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Small
} as const;

export const currentBreakpointPhone = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Phone
} as const;

export const currentBreakpointTablet = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Tablet
} as const;

export const currentBreakpointLarge = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Large
} as const;

export const currentBreakpointDesktop = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Desktop
} as const;

export const currentBreakpointHuge = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Huge
} as const;

export const currentBreakpointUltra = {
  type: UPDATE_CURRENT_BREAKPOINT,
  breakpoint: MediaQuery.Ultra
} as const;

export const setMqCookie = (breakpoint: MediaQuery) =>
  setCookie('mq', breakpoint.toString(), { days: 365 });
